const accountTypeOptions = [
    {
        id: 1,
        name: '试用',
    },
    {
        id: 2,
        name: '付费',
    },
]
const statusOptions = [
    {
        id: 1,
        name: '正常',
    },
    {
        id: 2,
        name: '禁用',
    },
]

const seatColumns = [
    {
        title: '坐席编号',
        dataIndex: 'seat',
        width: 120
    },
    {
        title: '外显号码',
        dataIndex: 'phone',
        width: 120
    },
    {
        title: '归属地',
        dataIndex: 'city',
        width: 120
    },
    {
        title: '已被使用企业',
        dataIndex: 'name',
        width: 120
    }
]

const dashboardColumns = [
    {
        title: '菜单编号',
        dataIndex: 'code'
    },
    {
        title: '名称',
        dataIndex: 'name',
        width: 120
    },
    {
        title: 'url',
        dataIndex: 'url',
        slots: { customRender: 'url' }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        slots: { customRender: 'operation' },
        width: 120
    }
]

export { accountTypeOptions, statusOptions, seatColumns, dashboardColumns }
